import type { CustomerBasketQuoteRequest } from "@shared-core/data/customer-basket-types";
import { Card } from "../../../app/components/primitives/card";
import { Button } from "../../../app/components/primitives/button";

// An item the customer asked us to price (a paper we don't list, spec 32 §5.7): it sits in the basket with no price,
// and the basket is sent to us for a price rather than ordered. Only removing it is a change; its quantity and paper
// are changed by removing it and adding it again from its page.
export function QuoteRequestCard({
  request,
  canChange,
  busy,
  error,
  onRemove,
}: {
  request: CustomerBasketQuoteRequest;
  canChange: boolean;
  busy: boolean;
  error: string | null;
  onRemove: (request: CustomerBasketQuoteRequest) => void;
}) {
  return (
    <Card className="space-y-2 p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 space-y-0.5">
          <p className="font-medium">{request.title}</p>
          {request.spec && (
            <p className="text-sm text-muted-foreground">{request.spec}</p>
          )}
          <p className="text-sm text-muted-foreground">{request.reason}</p>
        </div>
        <p className="shrink-0 text-right">
          <span className="block font-semibold">Quote on request</span>
          <span className="block text-sm tabular-nums text-muted-foreground">
            {request.quantity.toLocaleString("en-GB")}
          </span>
        </p>
      </div>
      {request.delivery_address_name && (
        <p className="text-sm text-muted-foreground">
          To {request.delivery_address_name}
        </p>
      )}
      {canChange && request.actions.remove_url !== null && (
        <Button
          variant="ghost"
          size="sm"
          className="px-0"
          disabled={busy}
          onClick={() => onRemove(request)}
        >
          Remove
        </Button>
      )}
      {error && (
        <p role="alert" className="text-sm text-red-700 dark:text-red-400">
          {error}
        </p>
      )}
    </Card>
  );
}
